import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ToastrService} from 'ngx-toastr';
import {History} from "@app/interfaces/history";
import {ConstantsService} from "@app/services/constants/constants.service";
import {BridgeService} from "@app/services/bridge/bridge.service";
import {Subscription} from 'rxjs/internal/Subscription';
import {MyWebDeskService} from "@components/my-web-desk/my-web-desk.service";
import {environment} from "@env/environment";

@Component({
    selector: 'app-sidebar-content-watching-center',
    templateUrl: './sidebar-content-watching-center.component.html',
    styleUrls: ['./sidebar-content-watching-center.component.css']
})
export class SidebarContentWatchingCenterComponent implements OnInit {
    allWathcingTasks = [];
    total = 0;
    totalForValid = 0;

    today = new Date();
    dd = String(this.today.getDate()).padStart(2, '0');
    mm = String(this.today.getMonth() + 1).padStart(2, '0');
    yyyy = this.today.getFullYear();
    date;
    dateY;
    allTasksForValidation = [];
    user: any[] = [];
    cliUrl = environment.cliURL;

    @Output() outputTotalTasksForValidation = new EventEmitter<any>();


    constructor(public taskService: TaskService,
                public toastr: ToastrService,
                public constants: ConstantsService,
                private bridge: BridgeService, public webSrvC: MyWebDeskService) {


    }

    ngOnInit(): void {
        this.dd = String(this.today.getDate()).padStart(2, '0');
        this.mm = String(this.today.getMonth() + 1).padStart(2, '0');
        this.yyyy = this.today.getFullYear();
        this.date = this.dd + '.' + this.mm + '.';
        this.dateY = this.dd + '.' + this.mm + '.' + this.yyyy + '.';

        this.getAllWatchingTasks();
        this.getTasksForValidation();
        this.user = this.constants.userData;

    }

    getAllWatchingTasks() {
        this.taskService.getAllWatchingTasksByUser().subscribe(result => {
            if (result.type === 'success') {
                this.allWathcingTasks = result.data;
                this.total = this.allWathcingTasks.length;
            }


        });
    }

    getTasksForValidation() {
        this.taskService.getTasksForValidation().subscribe(result => {
            if (result.type === 'success') {
                this.allTasksForValidation = result.data;
                this.totalForValid = this.allTasksForValidation.length;
                this.outputTotalTasksForValidation.emit(this.totalForValid);

            }


        });
    }

    async validateTask(task, value) {
        const val = {
            id: task._id,
            validate: value,
            sort: task.sort
        };
        this.taskService.validateTask(val).subscribe((response) => {
            if (response.type === 'success') {
                let message = value == false ?
                    'Validator ' + this.user['first_name'] + ' ' + this.user['last_name'] +
                    ' je odbio zahtjev za odobravanje zadatka. Zadatak je vraćen na ponovno izvršavanje.' :
                    'Validator ' + this.user['first_name'] + ' ' + this.user['last_name'] + ' je odobrio zadatak.';
                this.toastr.success(response.message);
                const items: History = {
                    task_id: task._id,
                    user_id: parseInt(this.constants.creator_id, 10),
                    type: 'validation',
                    action: 'insert',
                    sort: task.sort,
                    message: message,
                    data: {validated: value},
                    task_identifier: task.identifier

                };
                const fun1 = this.taskService.taskChange(items);
                this.getTasksForValidation();
                let link = this.cliUrl + '/view-task/' + task._id;
                const notif = {
                    notification: {
                        title: message,
                        description: 'Zadatak: ' + task['title'],
                        employers: task['assigned'],
                        type: 'informacija',
                        link: link
                    }
                };
                
                const fun2 = this.bridge.sendDataViaBridge(notif);
            } else if (response.type === 'info') {
                this.toastr.info(response.message);
                return;
            } else {
                this.toastr.error('Došlo je do greške. Molimo Vas obratite se korisničkoj podršci.');
            }
        });
    }


}
